import React, { useState } from 'react';
import Styled from 'styled-components';
import Icon from '@components/Icon';
import { Flex } from '@components/layout/Grid';

const Language = Styled.button<{ selected?: boolean }>`
  flex-shrink: 0;
  position: relative;
  width: 30px;
  height: 30px;
  border: 1px solid ${({ selected }) => (selected ? '#129EDC' : 'transparent')};
  border-radius: 50%;
  padding: 1px;
  margin-left: 14px;
  background: none;
  box-sizing: border-box;
  cursor: pointer;
  outline: none;

  i {
    position: absolute;
    top: 0;
    right: 0;
    border: 1px solid #129EDC;
    border-radius: 50%;
    padding: 2px;
    background-color: white;
    transform: translate(25%, -25%);
  }
`;

const LanguageImage = Styled.img`
  width: 100%;
`;

const available_languages = {
  se: '/static/icons/se.png',
  en: '/static/icons/en.png',
  no: '/static/icons/no.png',
  fi: '/static/icons/fi.png',
};

type Languages = 'en' | 'se' | 'fi' | 'no';

type Props = {
  languages?: string[];
  onChange(arg0: string[]): void;
  enabledLanguages?: Languages[];
};
const Languages = ({
  onChange,
  languages = null,
  enabledLanguages = ['se', 'en'],
}: Props) => {
  const [selectedLanguages, setSelectedLanguages] = useState(
    languages || Object.keys(available_languages)
  );

  return (
    <Flex>
      {Object.entries(available_languages).map(([key, path]) => {
        if (!enabledLanguages.includes(key as Languages)) {
          return null;
        }
        const selected = selectedLanguages.includes(key);
        return (
          <Language
            key={key}
            selected={selected}
            onClick={() => {
              let langs = [...selectedLanguages];
              if (selected) {
                // we always want one item selected
                if (selectedLanguages.length > 1) {
                  langs = langs.filter(lang => lang !== key);
                }
              } else {
                langs.push(key);
              }

              setSelectedLanguages([...langs]);
              onChange([...langs]);
            }}
          >
            <LanguageImage src={path} />
            {selected ? (
              <Icon name="ygb-icon-checkmark" fontSize="8px" color="#129EDC" />
            ) : null}
          </Language>
        );
      })}
    </Flex>
  );
};

export default Languages;
